import { StateCreator } from 'zustand';

export interface UISlice {
  // State
  selectedTab: 'tree' | 'planning';
  showSettingsPopup: boolean;
  showBPlotModal: boolean;
  hasBPlotBeenCompleted: boolean;
  hasSeenBPlotIntro: boolean;
  showWordLimitWarning: boolean;
  showWorldStateModal: boolean;
  pendingWorldChoice: 'good' | 'bad' | null;
  clickedChoiceIndex: number | null;

  // Actions
  setSelectedTab: (tab: 'tree' | 'planning') => void;
  setShowSettingsPopup: (show: boolean) => void;
  setShowBPlotModal: (show: boolean) => void;
  setHasBPlotBeenCompleted: (completed: boolean) => void;
  setHasSeenBPlotIntro: (seen: boolean) => void;
  setShowWordLimitWarning: (show: boolean) => void;
  setShowWorldStateModal: (show: boolean) => void;
  setPendingWorldChoice: (choice: 'good' | 'bad' | null) => void;
  setClickedChoiceIndex: (index: number | null) => void;
}

export const createUISlice: StateCreator<UISlice, [], [], UISlice> = (set) => ({
  // Initial state
  selectedTab: 'tree',
  showSettingsPopup: false,
  showBPlotModal: false,
  hasBPlotBeenCompleted: false,
  hasSeenBPlotIntro: false,
  showWordLimitWarning: false,
  showWorldStateModal: false,
  pendingWorldChoice: null,
  clickedChoiceIndex: null,

  // Actions
  setSelectedTab: (tab) =>
    set(() => ({
      selectedTab: tab,
    })),

  setShowSettingsPopup: (show) =>
    set(() => ({
      showSettingsPopup: show,
    })),

  setShowBPlotModal: (show) =>
    set(() => ({
      showBPlotModal: show,
    })),

  setHasBPlotBeenCompleted: (completed) =>
    set(() => ({
      hasBPlotBeenCompleted: completed,
    })),

  setHasSeenBPlotIntro: (seen) =>
    set(() => ({
      hasSeenBPlotIntro: seen,
    })),

  setShowWordLimitWarning: (show) =>
    set(() => ({
      showWordLimitWarning: show,
    })),

  setShowWorldStateModal: (show) =>
    set(() => ({
      showWorldStateModal: show,
    })),

  setPendingWorldChoice: (choice) =>
    set(() => ({
      pendingWorldChoice: choice,
    })),

  setClickedChoiceIndex: (index) =>
    set(() => ({
      clickedChoiceIndex: index,
    })),
});
